export default __webpack_public_path__ + "static/media/whatsapp.f2e05ee6.svg";